<template>
  <div>
    <PageAllow controller="Quotations" action="index" />
    <Breadcrumbs :items="items" />

    <!-- <v-slide-x-transition> -->
    <v-sheet class="transparent-background-color">
      <v-sheet class="transparent-background-color">
        <!-- id="fix-header"
        v-resize="$mainResizer"
        :class="
          ($vuetify.rtl ? 'fix-header-rtl ' : 'fix-header ') +
          (mainContentScrolled ? 'elevation-2' : 'transparent-background-color')
        " -->
        <v-row dense class="mx-5">
          <v-col cols="12" sm="12" md="4">
            <v-row dense align="center" class="pa-1 pe-2">
              <SearcherDatetimeRangeWithRadio
                v-model="options"
                type="datetime"
                show-radios
                :radios="datetimeRadios"
              />
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="8" align-self="center">
            <v-row dense align="center" class="search-controls">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="px-0 py-0 caption font-weight-bold grey--text"
                    color="primary"
                    @click.stop="onSearch()"
                  >
                    <v-icon small class="pe-1">fa-search</v-icon>
                    {{ $t("Search.search") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.searchTip") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="caption font-weight-bold grey--text"
                    @click.stop="resetSearch()"
                  >
                    <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                    {{ $t("Search.reset") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.resetTip") }}</span>
              </v-tooltip>
              <v-divider vertical />
              <v-btn
                class="caption font-weight-bold grey--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
                small
                text
                @click.stop="$store.commit('toggleSearchPanel')"
              >
                {{ $t("Search.pro") }}
                <v-icon small class="ps-1">{{
                  $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
                }}</v-icon>
              </v-btn>
              <v-spacer />
              <!-- 新增 -->
              <v-btn
                small
                color="print"
                dark
                class="ms-1"
                v-if="
                  !$route.path.startsWith('/question-') &&
                  $permission.permissionAllow('Quotations', 'add')
                "
                href="/#/question/new"
              >
                {{ $t("Question.add") }}
              </v-btn>
            </v-row>
          </v-col>
        </v-row>
        <v-expansion-panels
          v-model="$store.getters.panels"
          multiple
          flat
          accordion
        >
          <v-expansion-panel class="transparent-background-color">
            <v-expansion-panel-content>
              <v-row dense align="center">
                <!-- 报价单号 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherKeyword
                    ref="quotation_code"
                    v-model="options.quotation_code"
                    @text="quotation_code = $event"
                    :label="$t('Question.quotation_code')"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="4"> </v-col>
                <v-col cols="12" sm="6" md="4"> </v-col>
                <!-- 报价单状态 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherStatus
                    v-model="options.status"
                    :label="$t('Question.status.title')"
                    :items="$consts.questionFlgs"
                  />
                </v-col>
                <!-- 是否有疑义 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherStatus
                    v-model="options.question_flgs"
                    :label="$t('Question.questionDoubtFlg.title')"
                    :items="$consts.questionDoubtFlgs"
                  />
                </v-col>
                <!-- 作废报价单 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherStatus
                    v-model="options.cancel_flgs"
                    :label="$t('Question.cancelFlgs.title')"
                    :items="$consts.cancelFlgs"
                  />
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-sheet>
      <!-- 表格 -->
      <div class="mx-4 mb-4">
        <!-- :style="'padding-top: ' + fixHeaderHeightInPx + 'px'" -->
        <v-data-table
          :headers="headers"
          :items="quotations"
          :options.sync="options"
          :loading="loading"
          :page.sync="paging.page"
          :server-items-length="paging.count"
          multi-sort
          class="elevation-1 px-4 pt-1"
          :footer-props="$t('$config.footer-props')"
        >
          <template v-slot:header.actions="{ header }">
            {{ header.text }}
            <v-icon x-small>fa-sliders-h</v-icon>
          </template>
          <!-- 按钮  -->
          <template v-slot:item.actions="{ item }">
            <v-tooltip
              top
              v-if="$permission.permissionAllow('Quotations', 'view')"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  v-bind="attrs"
                  v-on="on"
                  dark
                  color="info"
                  class="px-2 me-2"
                  :href="'/#/question/' + item.id"
                >
                  <!-- <v-icon x-small class="pe-1">fa-align-left</v-icon> -->
                  {{ $t("Question.detail") }}
                </v-btn>
              </template>
              <span>{{ $t("CRUD.viewInfo", [$t("Question.detail")]) }}</span>
            </v-tooltip>
            <v-tooltip
              top
              v-if="
                item.actions.edit &&
                $permission.permissionAllow('Quotations', 'edit')
              "
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  v-bind="attrs"
                  v-on="on"
                  dark
                  color="info"
                  class="px-2 me-2"
                  @click.stop="
                    $permission.checkAccountExpired().then(() => {
                      detailMode
                        ? $emit('edit')
                        : $router.push('/question/' + item.id + '/edit');
                    })
                  "
                >
                  <!-- <v-icon x-small class="pe-1">fa-align-left</v-icon> -->
                  {{ $t("Question.modify") }}
                </v-btn>
              </template>
              <span>{{ $t("CRUD.viewInfo", [$t("Question.modify")]) }}</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  v-bind="attrs"
                  v-on="on"
                  dark
                  color="action"
                  class="px-2 me-2"
                  @click.stop="Export(item.id)"
                >
                  <!-- <v-icon x-small class="pe-1">fa-align-left</v-icon> -->
                  {{ $t("Question.export") }}
                </v-btn>
              </template>
              <span>{{ $t("CRUD.viewInfo", [$t("Question.export")]) }}</span>
            </v-tooltip>
          </template>

          <template v-slot:item.status="{ item }">
            <!-- 1待确认 2待审核 3已完成 -->
            <!-- 0无疑议 1有疑议 -->
            <!-- 0正常 1已作废 -->
            <!-- 待确认(有疑议) -->
            <!-- 报价单状态：{{item.status}}
            是否疑议：{{item.question_flg}} 
            是否作废：{{ item.cancel_flg }} -->
            <v-chip
              small
              label
              color="primary"
              :text-color="item.status | questionFlgsTextColor"
            >
              <span>
                {{ item.status | questionFlgsText }}
                <span v-if="item.question_flg == 1">
                  {{ "(" }}{{ item.question_flg | questionDoubtFlgsText
                  }}{{ ")" }}
                </span>
              </span>
            </v-chip>
            <br />
            <v-chip
              v-if="item.cancel_flg == 1"
              x-small
              label
              outlined
              color="danger"
            >
              {{ $t("CRUD.cancelled") }}
            </v-chip>
          </template>
        </v-data-table>
      </div>
    </v-sheet>
    <!-- </v-slide-x-transition> -->
  </div>
</template>

<script>
import Breadcrumbs from "@/components/Breadcrumbs";
import i18n from "@/i18n";
import { mapState } from "vuex";
import SearcherDatetimeRangeWithRadio from "@/components/plugins/SearcherDatetimeRangeWithRadio";
import PageAllow from "@/components/PageAllow";
import Quotations from "@/api/quotations";
import SearcherStatus from "@/components/plugins/SearcherStatus";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";

// import MaterialAnalyze from "@/api/material_analyze";

const defaultOptions = {
  datetimeRadioSelected: "created",
  created_time_from:
    new Date(new Date().getTime() - 30 * 24 * 3600 * 1000)
      .toISOString()
      .substr(0, 10) + " 00:00:00",
  created_time_to: new Date().toISOString().substr(0, 10) + " 23:59:59",
  status: [1, 2, 3],
  question_flgs: [0, 1],
  cancel_flgs: [0, 1],
  quotation_code: "",
};

export default {
  data: () => ({
    quotations: [],
    paging: {},
    options: JSON.parse(JSON.stringify(defaultOptions)),
    loading: false,
    quotation_code: "",
  }),

  components: {
    Breadcrumbs,
    PageAllow,
    SearcherStatus,
    SearcherKeyword,
    SearcherDatetimeRangeWithRadio,
  },

  props: {
    order: Object,
    detailMode: Boolean,
  },

  computed: {
    // eslint-disable-next-line vue/return-in-computed-property
    accountUserName() {
      if (this.accountInfo && this.accountInfo.account_name)
        return this.accountInfo.account_name;
    },
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.question"),
        disabled: false,
        href: "/question",
      },
      {
        text: i18n.t("Nav.questionIndex"),
        disabled: true,
        href: "/question",
      },
    ],
    datetimeRadios: () => [
      {
        key: "created",
        text: i18n.t("Delivery.Fields.created_time"),
      },
    ],
    headers: () => [
      {
        text: i18n.t("Question.Fields.purchase_code"),
        align: "start",
        sortable: false,
        value: "quotation_code",
      },
      {
        text: i18n.t("Question.Fields.created"),
        align: "start",
        sortable: false,
        value: "created",
      },
      {
        text: i18n.t("Question.Fields.num"),
        align: "end",
        sortable: false,
        value: "count_material",
      },
      {
        text: i18n.t("Question.Fields.question_flgs"),
        align: "center",
        sortable: false,
        value: "status",
      },
      {
        text: i18n.t("TableHeaders.actions"),
        align: "start",
        sortable: false,
        value: "actions",
      },
    ],
    ...mapState([
      "accountInfo",
      "accountUser",
      "fixHeaderHeightInPx",
      "mainContentScrolled",
    ]),
  },

  mounted() {
    this.$commonUtils.loadOptions("question").then(
      function (data) {
        if (data.options) {
          this.options = data.options;
        } else this.resetSearch();
      }.bind(this)
    );
  },

  methods: {
    onSearch() {
      this.options = Object.assign(this.options, {
        quotation_code: this.quotation_code,
      });
      this.getQuotationsFromAPI();
    },
    resetSearch() {
      this.options = JSON.parse(JSON.stringify(defaultOptions));
    },
    getQuotationsFromAPI() {
      this.loading = true;
      Quotations.fetch(this.id, this.options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.quotations = response.data.quotations;
            this.paging = response.data.paging;
          } else if (response.data.error.code.isNoResultSet()) {
            this.options.page = 1;
          }
          this.loading = false;
        }.bind(this)
      );
    },

    Export(id) {
      Quotations.exportOne(Object.assign(id));
    },
  },

  watch: {
    accountUser: {
      handler() {
        if (this.accountUser && this.accountUser.supplier_id) {
          this.id = this.accountUser.supplier_id;
          this.getQuotationsFromAPI();
        }
      },
    },
    options: {
      deep: true,
      handler() {
        sessionStorage.setItem(
          "question-options",
          JSON.stringify(this.options)
        );

        if (this.accountUser && this.accountUser.supplier_id) {
          this.id = this.accountUser.supplier_id;
          this.getQuotationsFromAPI();
        }
      },
    },
  },
};
</script>

<style>
</style>